<div class="dialog-content-min">
  <form [formGroup]="currencyForm">
    <div class="col-12 lg:col-12 md:col-12 sm:col-12">
      <label for="name" class="required-label">Currency Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
      <textarea class="form-control" placeholder="Enter Currency Name" id="name" formControlName="name" name="name"
        pInputTextarea></textarea>
      <span style="color:red"
        *ngIf="currencyForm.get('name').invalid && (currencyForm.get('name').dirty || currencyForm.get('name').touched)">
        {{getErrorMessage(currencyForm ,validation_message,'name')}}
      </span>
    </div>

    <div class="field col-12 lg:col-12 md:col-12 sm:col-12">
      <label for="defaultflag">Default Flag <span class="required-label"
          style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
      <p-dropdown [options]="activestatus" [filter]="true" appendTo="body" name="defaultflag" optionLabel="labelname"
        optionValue="value" formControlName="defaultflag" placeholder="Select"></p-dropdown>
      <span style="color:red"
        *ngIf="currencyForm.get('defaultflag').invalid && (currencyForm.get('defaultflag').dirty || currencyForm.get('defaultflag').touched)">
        {{getErrorMessage(currencyForm ,validation_message,'defaultflag')}}
      </span>
    </div>
  </form>
</div>
<div class="custom-dialog-footer">
  <p-button class="m-1" label="Close" styleClass="customeclose"
    (click)="closemodal(currencyForm,this.ref,'Are you sure you want to Close?')"></p-button>
  <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
    (click)="addCurrency()"></p-button>
</div>